export default __webpack_public_path__ + "static/icon-andy-signature--mobile-f3323db6b9516d634111d376b9baac13.png";